// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel.js';
import type { EntlibFailureEServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel } from './entlibFailureEServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel.js';
import type { EntlibResponseEServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel } from './entlibResponseEServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class OrchestratorV1FetchResultRequestResponse {
    'data': EServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof OrchestratorV1FetchResultRequestResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsFetchResultResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return OrchestratorV1FetchResultRequestResponse.attributeTypeMap;
    }
}
